import { applySeo } from "@/lib/seo-head";
import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/site/Layout";
import { OfficesSection } from "@/components/site/OfficesSection";
import { OfficeMap } from "@/components/site/OfficeMap";
import officesHero from "@/assets/offices-hero.jpg";
import { useT } from "@/lib/i18n";

export const Route = createFileRoute("/about/oficinas")({
  component: Oficinas,
  head: (ctx) => applySeo(ctx.matches, ((_c: unknown) => ({
    meta: [
      { title: "Oficinas — RR Lex Juristas" },
      { name: "description", content: "Sedes de RR Lex Juristas en España, Portugal y Brasil. Encuentra la oficina más cercana y reserva una reunión." },
      { property: "og:title", content: "Oficinas RR Lex Juristas" },
      { property: "og:description", content: "Presencia internacional: España, Portugal y Brasil." },
      { property: "og:url", content: "https://rrlexjuristas.com/about/oficinas" },
      { property: "og:image", content: officesHero },
    ],
    links: [{ rel: "canonical", href: "https://rrlexjuristas.com/about/oficinas" }],
  }))(ctx)),
});

function Oficinas() {
  const { tk } = useT();

  return (
    <Layout>
      <section className="relative border-b border-gold/15">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${officesHero})` }}
          aria-hidden
        />
        <div className="absolute inset-0 bg-background/75 backdrop-blur-[2px]" aria-hidden />
        <div className="relative max-w-7xl mx-auto px-6 py-24 md:py-32 text-center">
          <span className="text-xs tracking-[0.4em] uppercase text-gold">
            {tk("offices.kicker", "Presencia internacional")}
          </span>
          <h1 className="font-serif text-5xl md:text-7xl mt-5 max-w-4xl mx-auto">
            {tk("offices.title.a", "Nuestros ")}
            <em className="not-italic gold-gradient">{tk("offices.title.b", "despachos")}</em>
          </h1>
          <p className="mt-6 text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            {tk(
              "offices.intro",
              "Atendemos a clientes desde sedes en España, Portugal y Brasil. Reserva una reunión en la oficina más cercana.",
            )}
          </p>
        </div>
      </section>

      <OfficesSection />
      <OfficeMap />
    </Layout>
  );
}
